import React, { useState, useEffect } from "react";
import { Form, Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from 'yup';
import Button from "web/components/Button";
import TextInput from "web/components/form-elements/TextInput";
// import AlertModal from "web/components/AlertModal";
import CloseIcon from "web/assets/images/CloseIcon.png";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import "./alert.scss";
import styled from "styled-components";
import Select from 'web/components/form-elements/Select';

export default ({ isOpen, toggle, draftTitleVal, content, link, acknowledgeCallBack, }) => {
  // const dispatch = useDispatch();
  const [pageContent, setPageContent] = useState()
  const [editedPageContent, setEditedPageContent] = useState()
  const [contentUpdated, setContentUpdated] = useState(false)

  const redirectLink = (link) => {
    toggle(!isOpen);
  };
  // const token = localStorage.getItem("token");
  localStorage.removeItem("isTnCAcknowledged");

  useEffect(() => {
    setPageContent(content)
    setContentUpdated(draftTitleVal ? true : false)
  }, [isOpen])

  const createMarkupForPageContent = () => {
    if (pageContent) return { __html: pageContent }
  }

  const updateContent = (e) => {
    let outerDivContent = e.target.outerHTML
    let split1 = outerDivContent.indexOf('<termtext>')
    let split2 = outerDivContent.indexOf('</termtext>')
    let finalHtmlContent = outerDivContent.substring(split1, split2 + 10)
    setEditedPageContent(finalHtmlContent)
    setContentUpdated(true)
  }

  const INITIAL_VALUES = {
    draftTitle: draftTitleVal ? draftTitleVal : '',
  };

  const VALIDATION_SCHEMA = () => {
    let schemaAttributes = {
      draftTitle: Yup.string().trim().required('Title is required.'),
    }

    return Yup.object().shape(schemaAttributes);
  }

  const buttonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', cursor: 'pointer' }
  const disabledButtonStyle = { background: '#61b01f', background: 'linear-gradient(to bottom, #61b01f 0%,#27911b 100%)', color: 'white', whiteSpace: 'nowrap', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '2px', opacity: 0.5 }

  const [userRole, setUserRole] = useState();
  const userRoleList = [
    { value: 'GUEST', label: 'Guest' },
    { value: 'MEMBER', label: 'Member' },
  ]

  return (
    <>
      <div className="alert-modal">
        <Modal
          isOpen={isOpen}
          toggle={toggle}
          backdrop={"static"}
          centered={true}
          className="acknowledgeModal"
        >
          <div>
            <div className="header">
              <Button
                handleClick={() => {
                  redirectLink(link);
                }}
              >
                <img src={CloseIcon} className="closeIcon" alt="close-icon" />
              </Button>
              <h3>System Operational Terms & Conditions</h3>
            </div>
            <ModalBody>
              {pageContent ?
                <div className="modal-content">
                  <Formik
                    initialValues={INITIAL_VALUES}
                    validationSchema={VALIDATION_SCHEMA()}
                    onSubmit={(values) => { }}
                  >
                    {(props) => {
                      // const { isValid, dirty, values, errors, touched } = props;
                      return (
                        <>
                          <Form>
                            <TermText>
                              <div contenteditable='true' dangerouslySetInnerHTML={createMarkupForPageContent()} onInput={updateContent} />
                            </TermText>
                            <TextInput
                              name="draftTitle"
                              // inputType="textAndNumber"
                              placeholder={"Title for Terms and Conditions"}
                            />
                            <Select
                              name='userRoles'
                              data={userRoleList}
                              placeholder='Select Type'
                              searchable={false}
                              onChangeHandler={(data) => {
                                setUserRole(data.value)
                              }}
                            />
                            <div style={{ display: 'flex', justifyContent: 'end', marginTop: '1rem' }}>
                              <button
                                style={(props.values.draftTitle === '' || !contentUpdated) ? disabledButtonStyle : buttonStyle}
                                disabled={props.values.draftTitle === '' || !contentUpdated}
                                onClick={() => {
                                  acknowledgeCallBack(editedPageContent, props.values.draftTitle, 'edited', userRole)
                                  toggle()
                                }}>
                                Save Draft
                              </button>
                              <button
                                style={buttonStyle}
                                onClick={() => toggle()}>
                                Cancel
                              </button>
                            </div>
                          </Form>
                        </>
                      );
                    }}
                  </Formik>
                </div>
                :
                <p>
                  Content Not Available
                </p>
              }
            </ModalBody>
            <ModalFooter className="modal-footer"></ModalFooter>
          </div>
        </Modal>
      </div>
    </>
  );
};

const TermText = styled.div`
  overflow: auto;
  height: calc(100vh - 470px);
  text-align: left;
  border: 2px solid #ccc;
  margin: 25px 0;
  padding: 10px;
  p {
    color: #191819 !important;
      font-size: 16px !important;
      line-height: normal !important;
        text-align: justify !important;
        margin-bottom: 10px !important;
  }
  .checkbox-field {
    margin-top: 50px;
  }
`;